// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const FINANCIAL_DATA_SEPARATOR_PROPS = {
  variant: VARIANTS.LineSeparatorVariantsType.DECORATIVE,
};

export { FINANCIAL_DATA_SEPARATOR_PROPS };
